<h1 class="titulo mb-3">Publicação da vaga</h1>
<mat-divider class="mb-8"></mat-divider>
<div class="row">
    <div class="col-12 col-md-8">
        <p class="vaga-publicacao-paragrafo mb-10">
            Defina quando você quer que sua vaga seja publicada para os candidatos.
        </p>
    </div>
    <div *ngIf="!view && !edit" class="col-12 col-md-4 d-flex justify-content-end">
        <app-checkbox [title]="'Lançar vaga agora'" (selectedOptionChange)="updateFilter($event)"></app-checkbox>
    </div>
</div>
<div class="row mb-5">
    <div class="col-12 col-md-4 mr-3">
        <div class="form-group">
            <label class="form-label required" for="dataPublicacao">Data de publicação</label>
            <div class="input-wrapper">
                <img src="../../../../assets/img/vagas/calendario.svg" alt="Calendário" class="input-icon" />
                <input [disabled]="view || lancarAgora" required type="text" class="form-control" name="dataPublicacao" id="dataPublicacao"
                    maxlength="10" placeholder="DD/MM/AAAA" [(ngModel)]="dataInicioFormatada" [mask]="'d0/M0/0000'"
                    (ngModelChange)="onDateChange($event)" />

            </div>
        </div>
    </div>
    <div class="col-12 col-md-4">
        <div class="form-group">
            <label class="form-label required" for="horaPublicacao">Hora de publicação</label>
            <div class="input-wrapper">
                <img src="../../../../assets/img/vagas/relogio.svg" alt="Relógio" class="input-icon" />
                <input [disabled]="view || lancarAgora" required type="text" class="form-control" name="horaPublicacao" id="horaPublicacao" maxlength="5"
                    placeholder="00:00" [(ngModel)]="horaInicioFormatada" [mask]="'Hh:m0'"
                    (ngModelChange)="onTimeChange($event)" />

            </div>
        </div>
    </div>
</div>

<p class="vaga-publicacao-paragrafo mb-10">
    Defina até quando esta vaga ficará aberta para candidaturas. (Opcional)
</p>
<div class="row mb-5">
    <div class="col-12 col-md-4 mr-3">
        <div class="form-group">
            <label class="form-label" for="dataPublicacao">Data de Encerramento Candidaturas</label>
            <div class="input-wrapper">
                <img src="../../../../assets/img/vagas/calendario.svg" alt="Calendário" class="input-icon" />
                <input [disabled]="view" required type="text" class="form-control" name="dataEncerramento" id="dataEncerramento"
                    maxlength="10" placeholder="DD/MM/AAAA" [(ngModel)]="dataTerminoInscricaoFormatada" [mask]="'d0/M0/0000'"
                    (ngModelChange)="onDateChangeTerminoInscricao($event)" />

            </div>
        </div>
    </div>
    <div class="col-12 col-md-4">
        <div class="form-group">
            <label class="form-label" for="horaPublicacao">Hora de Encerramento Candidaturas</label>
            <div class="input-wrapper">
                <img src="../../../../assets/img/vagas/relogio.svg" alt="Relógio" class="input-icon" />
                <input [disabled]="view" required type="text" class="form-control" name="horaEncerramento" id="horaEncerramento"
                    maxlength="5" placeholder="00:00" [(ngModel)]="horaTerminoInscricaoFormatada" [mask]="'Hh:m0'"
                    (ngModelChange)="onTimeChangeTerminoInscricao($event)" />

            </div>
        </div>
    </div>
</div>

<p class="vaga-publicacao-paragrafo mb-10">
    Defina até quando esta vaga ficará aberta para contratação. (Opcional)
</p>
<div class="row mb-5">
    <div class="col-12 col-md-4 mr-3">
        <div class="form-group">
            <label class="form-label" for="dataPublicacao">Data de Encerramento Contratações</label>
            <div class="input-wrapper">
                <img src="../../../../assets/img/vagas/calendario.svg" alt="Calendário" class="input-icon" />
                <input [disabled]="view" required type="text" class="form-control" name="dataEncerramento" id="dataEncerramento"
                    maxlength="10" placeholder="DD/MM/AAAA" [(ngModel)]="dataTerminoFormatada" [mask]="'d0/M0/0000'"
                    (ngModelChange)="onDateChangeTermino($event)" />

            </div>
        </div>
    </div>
    <div class="col-12 col-md-4">
        <div class="form-group">
            <label class="form-label" for="horaPublicacao">Hora de Encerramento Contratações</label>
            <div class="input-wrapper">
                <img src="../../../../assets/img/vagas/relogio.svg" alt="Relógio" class="input-icon" />
                <input [disabled]="view" required type="text" class="form-control" name="horaEncerramento" id="horaEncerramento"
                    maxlength="5" placeholder="00:00" [(ngModel)]="horaTerminoFormatada" [mask]="'Hh:m0'"
                    (ngModelChange)="onTimeChangeTermino($event)" />

            </div>
        </div>
    </div>
</div>
